import React, { useRef } from 'react'

import emptyImg from 'assets/images/empty.svg'

export const Image: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = ({
  alt = '',
  ...rest
}) => {
  const ref = useRef<HTMLImageElement>(null)

  const handleError = () => {
    if (ref?.current?.src) {
      ref.current.src = emptyImg
    }
  }

  return <img {...rest} ref={ref} alt={alt} onError={handleError} />
}
